export default __webpack_public_path__ + "static/media/DivineOpen.799cd354.jpg";